import { useState } from 'react';
import { PropTypes } from 'prop-types';
import Modal from '../../../../../components/Modal';

const MiniIMG = ({ fileList }) => {
  const [modalIMG, setModalIMG] = useState(null);
  const [showModal, setShowModal] = useState(false);

  if (fileList.length)
    return (
      <table className="dataTable">
        <tbody>
          <tr>
            <td
              colSpan="12"
              style={{
                backgroundColor: '#e6e6e6',
                padding: '0px',
                width: '100%',
              }}
            >
              <div
                // className='col-xs-12 col-sm-12 col-md-12'
                style={{
                  backgroundColor: '#ECECEC',
                  padding: '20px 0px',
                  display: 'flex',
                  justifyContent: 'center',
                  flexWrap: 'wrap',
                  // marginRight: '10px',
                }}
              >
                <Modal
                  open={showModal}
                  onCancel={() => {
                    setShowModal(false);
                    setModalIMG(null);
                  }}
                  width="50vw"
                  closable
                >
                  <img
                    src={modalIMG ? URL.createObjectURL(modalIMG) : ''}
                    alt="miniImg"
                  />
                </Modal>
                {fileList.map((file, index) => (
                  <div
                    key={index}
                    style={{
                      borderRadius: '5px',
                      margin: '5px',
                      padding: '5px',
                      width: '32%',
                      backgroundColor: 'white',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      boxShadow:
                        '0 1px 2px 0 rgba(0,0,0,.03), 0 1px 6px -1px rgba(0,0,0,.02), 0 2px 4px 0 rgba(0,0,0,.02)',
                    }}
                    onClick={() => {
                      setModalIMG(file);
                      setShowModal(true);
                    }}
                  >
                    <img
                      src={URL.createObjectURL(file)}
                      alt={`${file.originalName}`}
                    />
                  </div>
                ))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  return null;
};
MiniIMG.propTypes = {
  fileList: PropTypes.arrayOf(PropTypes.object).isRequired,
};

MiniIMG.propTypes = {
  fileList: PropTypes.arrayOf(PropTypes.object),
};

MiniIMG.defaultProps = {
  fileList: [],
};

export default MiniIMG;
